module.exports = __webpack_public_path__ + "img/harmonyOS_bg2.ff3a380e.jpg";